export var Categories;
(function (Categories) {
    /**
     * < 30%
     */
    Categories["C1"] = "< 30%";
    /**
     * 30% – 50%
     */
    Categories["C2"] = "30% \u2013 50%";
    /**
     * 50% – 80%
     */
    Categories["C3"] = "50% \u2013 80%";
    /**
     * 80% – 100%
     */
    Categories["C4"] = "80% \u2013 100%";
    /**
     * > 100%
     */
    Categories["C5"] = "> 100%";
})(Categories || (Categories = {}));
